var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSidebarOpen = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 16 16",
  fill: "currentcolor",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.5 1.75A2.75 2.75 0 0 0 1.75 4.5v7a2.75 2.75 0 0 0 2.75 2.75h7a2.75 2.75 0 0 0 2.75-2.75v-7a2.75 2.75 0 0 0-2.75-2.75h-7zm4.25 1.5H4.5c-.69 0-1.25.56-1.25 1.25v7c0 .69.56 1.25 1.25 1.25h4.25v-9.5zm1.5 9.5v-9.5h1.25c.69 0 1.25.56 1.25 1.25v7c0 .69-.56 1.25-1.25 1.25h-1.25z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgSidebarOpen);
export default ForwardRef;